import React from "react";
import Select from "react-select";
import { Tabs, Tab, Badge } from "react-bootstrap";
import { Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSync,
  faChartBar,
  faTrash,
  faPlus,
  faRocket,
  faChevronUp,
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";

import NumericLabel from "react-pretty-numbers";

import { PROJECT_MODES, PANEL_MODES } from "containers/Run/reducer";
import DeploymentItem from "containers/View/Item/DeploymentItem";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { PanelHeader, PanelBody, PanelFooter } from "components/Wizard/RightPanel/RightPanel";
import { getPrettyNumber } from "components/Home/Utils/Utils";

import modelGroupsIcon from "images/rightPanel/modelgroups.svg";
import closePanelIcon from "images/rightPanel/closepanel.svg";

import styles from "./style.module.css";

export default class ModelGroups extends React.Component {
  state = {
    selectVal: undefined,
    showOptions: true,
    addGroup: false,
    showArrows: true
  };

  handleCancel() {
    this.setState({
      addGroup: false
    });
  }

  handleShowAdd() {
    this.setState({
      addGroup: true
    });
  }

  handleAddGroup() {
    const { linkModelToGroup } = this.props;
    const { selectVal, showOptions, addGroup } = this.state;

    linkModelToGroup(selectVal);
    return this.setState({
      addGroup: false,
      selectVal: undefined
    });
  }

  handleSelectModelGroup(group, index) {
    const {
      updateSpecialIndex,
      updateRelatedId,
      createSetupFromSpecial,
      updateMode,
      originalId,
      mode,
      updatePanelMode
    } = this.props;
    updateSpecialIndex(index);
    if (group.job_id === undefined) {
      updateRelatedId(-1);
      createSetupFromSpecial(group.conditions);
      updatePanelMode(PANEL_MODES.MODEL_GROUPS, originalId);
    } else if (Number(group.job_id) !== Number(originalId)) {
      updatePanelMode(PANEL_MODES.MODEL_GROUPS, group.job_id);
      updateRelatedId(group.job_id);
    } else {
      updateRelatedId(originalId);
    }

    if (group.job_id !== undefined && mode === PROJECT_MODES.MONITOR_GROUP) {
      updateMode(PROJECT_MODES.MONITOR);
    }
  }

  renderAddGroup() {
    const { specialOptions } = this.props;

    const { selectVal, showOptions, showArrows, addGroup } = this.state;
    const selectedField = selectVal && selectVal.length > 0 && selectVal[0].field;

    return (
      <div className={styles.addGroupBody}>
        <h5>New Model</h5>
        <p>Specify Group</p>
        <Select
          options={
            //selectedField ? specialOptions.filter(elem => elem.field === selectedField) : specialOptions
            specialOptions
          }
          isMulti
          onChange={(val) =>
            this.setState({
              selectVal: val
            })
          }
          styles={{
            menu: (provided) => ({
              ...provided,
              zIndex: 200
            })
          }}
        />
        <div className={styles.addGroupLinks}>
          <a onClick={() => this.handleCancel()}>Cancel</a>
          <Button type="secondary" onClick={() => this.handleAddGroup()}>
            Save
          </Button>
        </div>
      </div>
    );
  }

  renderModelGroupItem(group, index, models) {
    const {
      specialIndex,
      modelGroupDeploy,
      deployModelGroup,
      updateMode,
      scrollToDataset,
      modelGroup,
      updatePriority,
      deleteSubModelGroup,
      retrainRun,
      scrollToStep
    } = this.props;
    const { selectVal, showOptions, showArrows, addGroup } = this.state;

    const isSelected = specialIndex === index || (specialIndex === undefined && index === models.length - 1);
    return (
      <div
        className={
          styles.modelGroupItem +
          " " +
          (isSelected ? styles.selectedModelGroupItem : "") +
          " " +
          (showArrows ? styles.modelGroupItemHover : "")
        }
        key={index}
        onClick={() => this.handleSelectModelGroup(group, index)}
        onMouseLeave={() => {
          if (!showArrows) {
            this.setState({ showArrows: true });
          }
        }}
      >
        <div className={styles.modelGroupTitle}>
          <h5>{group.name}</h5>
          <Badge bsClass={styles.modelGroupPriority}>{"Priority: " + (index + 1)}</Badge>
        </div>
        <p>
          <span>
            {!isNaN(group.impact) ? "Impact: " + getPrettyNumber(group.impact) : ""}
            {!isNaN(group.averageImpact) ? " (" + getPrettyNumber(group.averageImpact) + " Average)" : ""}
          </span>
        </p>
        <div className={styles.modelGroupActions}>
          <div className={styles.modeGroupButton} onClick={(e) => e.stopPropagation()}>
            {group.job_id === undefined ? (
              <Button
                type="secondary"
                onClick={() => {
                  updateMode(PROJECT_MODES.RUN);
                  this.handleSelectModelGroup(group, index);
                  scrollToDataset();
                }}
              >
                <FontAwesomeIcon icon={faChartBar} />
                <span>{"Create Model"}</span>
              </Button>
            ) : group.model_name ? (
              <Button type="secondary" onClick={() => retrainRun(group.job_id)} disabled={!group.isDone}>
                <FontAwesomeIcon icon={faSync} />
                <span>{group.isDone ? "Retrain Model" : "Deploying..."}</span>
              </Button>
            ) : (
              <Button
                type="secondary"
                onClick={() => {
                  updateMode(PROJECT_MODES.RUN);
                  this.handleSelectModelGroup(group, index);
                  scrollToStep(7);
                }}
                disabled={!group.isDone}
              >
                <FontAwesomeIcon icon={faRocket} />
                <span>{group.isDone ? "Deploy Model" : "Training..."}</span>
              </Button>
            )}
          </div>
          <div style={{ flexGrow: 1 }} />
          {showArrows && !modelGroup.isLoading && index !== modelGroup.models.length - 1 && (
            <div className={styles.manipulationActions} onClick={(e) => e.stopPropagation()}>
              <div className={styles.leftArrow}>
                <Button
                  type="secondary"
                  style={{
                    marginLeft: "5px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.setState({ showArrows: false });
                    updatePriority(index, 1);
                  }}
                  title="Increase Priority"
                  disabled={index <= 0}
                >
                  <FontAwesomeIcon icon={faChevronUp} />
                </Button>
              </div>
              <div className={styles.rightArrow}>
                <Button
                  type="secondary"
                  style={{
                    marginLeft: "5px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.setState({ showArrows: false });
                    updatePriority(index, -1);
                  }}
                  title="Decrease Priority"
                  disabled={index >= modelGroup.models.length - 2}
                >
                  <FontAwesomeIcon icon={faChevronDown} />
                </Button>
              </div>
              <div className={styles.trash}>
                <Button
                  type="secondary"
                  style={{
                    marginLeft: "15px",
                    paddingLeft: "5px",
                    paddingRight: "5px",
                    paddingTop: "2px",
                    paddingBottom: "2px"
                  }}
                  onClick={(event) => {
                    event.stopPropagation();
                    this.setState({ showArrows: false });
                    deleteSubModelGroup(index);
                  }}
                  title="Delete Sub-Group"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderDeployModelGroup() {
    const { modelGroupDeploy, deployModelGroup, updateMode, headModel } = this.props;

    if (!modelGroupDeploy) {
      if (headModel && headModel.isAdvanced) {
        return (
          <Button type="secondary" disabled>
            Unable to Deploy Advanced Model
          </Button>
        );
      } else {
        return (
          <Button type="secondary" onClick={() => deployModelGroup()}>
            Deploy Model Group
          </Button>
        );
      }
    }

    return (
      <div className={styles.modelGroupDeploy}>
        <div className={styles.modelGroupTitle}>
          <h5>{"Model Group Deployed:"}</h5>
        </div>
        <div style={{ margin: "0px auto" }}>
          <DeploymentItem data={modelGroupDeploy} noClick />
        </div>
        <a onClick={() => updateMode(PROJECT_MODES.MONITOR_GROUP)}>Monitor Model Group Deployment</a>
      </div>
    );
  }

  renderModelGroupBody() {
    const { modelGroup, createModelGroup } = this.props;

    const { selectVal, showOptions, addGroup } = this.state;
    const selectedField = selectVal && selectVal.length > 0 && selectVal[0].field;

    if (!modelGroup) {
      return (
        <div className={styles.modelGroupBody}>
          <div className={styles.createGroup}>
            <a onClick={() => createModelGroup()}>{"Create Specialized Models"}</a>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.modelGroupBody}>
        <div className={styles.addNewGroup + (addGroup ? " " + styles.addNewGroupExpand : "")}>
          <Button type="secondary" onClick={() => this.handleShowAdd()}>
            <FontAwesomeIcon icon={faPlus} />
            <span style={{ marginLeft: "5px" }}>{"Add New Model Specialization"}</span>
          </Button>
          {this.renderAddGroup()}
        </div>
        {modelGroup.models
          ? modelGroup.models.map((group, index, models) => this.renderModelGroupItem(group, index, models))
          : ""}
        <div className={styles.addNewGroup + " " + styles.addNewGroupNoBorder}>{this.renderDeployModelGroup()}</div>
      </div>
    );
  }

  render() {
    const { updatePanelMode, isModelGroupsLoading, deleteModelGroup, modelGroup } = this.props;

    return (
      <React.Fragment>
        <PanelHeader className={styles.whiteHeader}>
          <div className={styles.whiteHeaderTitle}>
            <img src={modelGroupsIcon} alt={"close panel"} />
            {"Model Groups"}
          </div>
          <Button type="secondary" onClick={() => updatePanelMode(PANEL_MODES.CLOSED)}>
            {"Close Panel"}
            {/* <img src={closePanelIcon} alt={"close panel"} /> */}
          </Button>
        </PanelHeader>
        <PanelBody hasPointer>{isModelGroupsLoading ? <LoadingIndicator /> : this.renderModelGroupBody()}</PanelBody>
        <PanelFooter className={styles.modelGroupsFooter}>
          <Button type="secondary" onClick={() => deleteModelGroup(modelGroup.id)}>
            Delete Model Group
          </Button>
        </PanelFooter>
      </React.Fragment>
    );
  }
}
